/**
 * Van stops and non-delivery idle for a day — zeecore /telematics/v1.
 */
import { API_ENDPOINTS } from '../config/api';
import { authenticatedFetch } from '../utils/authenticatedFetch';
import type { VehicleDayStopsResponse } from '../types/vehicleDayStops';

export async function fetchVehicleDayStops(date: string, options?: { signal?: AbortSignal }): Promise<VehicleDayStopsResponse> {
  const response = await authenticatedFetch(API_ENDPOINTS.telematicsV1.vehicleDayStops(date), { cache: 'no-store', signal: options?.signal });
  if (!response.ok) throw new Error(`Vehicle stops: HTTP ${response.status}`);
  // A path the proxy does not forward comes back as the app's index.html: say so, not "Unexpected token '<'".
  if (!(response.headers.get('content-type') ?? '').includes('json')) {
    throw new Error('Vehicle stops: the server returned a page, not data (is /telematics proxied to zeecore?)');
  }
  const json = (await response.json()) as VehicleDayStopsResponse;
  if (!Array.isArray(json.vehicles)) throw new Error('Vehicle stops response missing vehicles[]');
  return json;
}
